<template>
<div class="chapter">
<div class="inner_page">
<p class="C183"><strong><a id="page_vii">Contents</a></strong></p><a id="page_vii">
</a><p class="C186"><a id="page_vii"></a><a href="#/xhtml/05_List_of#page_ix">List of Illustrations</a></p>
<p class="C184"><a href="#/xhtml/06_Acknowle#page_xi">Acknowledgments</a></p>
<p class="C186"><a href="#/xhtml/07_Chapter#page_1">CHAPTER 1. Timing and Turnout: The Basics</a></p>
<p class="C186"><a href="#/xhtml/08_Chapter#page_16">CHAPTER 2. A Theory of Election Timing</a></p>
<p class="C186"><span href="#/xhtml/09_Chapter#page_37" title="Link target outside of Sample">CHAPTER 3. Partisan Power Play: Election Timing Politics in the Nineteenth Century</span></p>
<p class="C186"><span href="#/xhtml/10_Chapter#page_81" title="Link target outside of Sample">CHAPTER 4. Interest Groups and Election Timing Choice in the Twenty-First Century</span></p>
<p class="C186"><span href="#/xhtml/11_Chapter#page_126" title="Link target outside of Sample">CHAPTER 5. Estimating the Effect of Off-Cycle Election Timing: School Board Elections</span></p>
<p class="C186"><span href="#/xhtml/12_Chapter#page_167" title="Link target outside of Sample">CHAPTER 6. “What Election?” Timing, Turnout, and Policy in California Cities</span></p>
<p class="C184"><span href="#/xhtml/13_Chapter#page_200" title="Link target outside of Sample">CHAPTER 7. Implications for Democracy, Representation, and Institutional Stability</span></p>
<p class="C186"><span href="#/xhtml/14_Appendix#page_217" title="Link target outside of Sample">Appendixes</span></p>
<p class="C186"><span href="#/xhtml/15_Notes#page_235" title="Link target outside of Sample">Notes</span></p>
<p class="C186"><span href="#/xhtml/16_Index#page_269" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?998941ce